import { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';

import Api from '../../helpers/api';
import { toast } from 'react-toastify';

const api = new Api();

const FormPasswrod = (props) => {
    const [show, setShow] = useState(false)
    const [formData, setFormData] = useState({})
    const [loading, setLoading] = useState({})
    const [errors, setErrors] = useState({})

    const [inputPassword, setInputPassword] = useState({
        type: 'password',
        icon: 'far fa-eye icon',
    })

    useEffect(() => {
        setShow(props.showModal)
        setErrors({})
    }, [props.showModal])

    const handleInput = (e, name) => {
        setFormData({ ...formData, [name]: e.target.value })
    }

    const handleClose = () => {
        setShow(false)
        props.handleShowModal(false)
    }

    const handleChangeEyeIcon = (icon) => {
        if (icon == 'far fa-eye icon') {
            setInputPassword({
                type: 'text',
                icon: 'far fa-eye icon fa-eye-slash',
            })
            return
        }

        setInputPassword({
            type: 'password',
            icon: 'far fa-eye icon',
        })
    }

    const onSubmit = () => {
        setLoading({ ...loading, updatePassword: true })
        api.changePassword(formData)
            .then(response => {
                setLoading({ ...loading, updatePassword: false })
                handleClose()
                toast.success(response?.data?.meta?.message)
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, updatePassword: false })
                toast.error(data?.meta?.message)
            })
    };

    return (
        <div
            className="modal show"
            style={{ display: 'block', position: 'initial' }}
        >
            <Modal show={show} onHide={handleClose}>
                <Modal.Body>
                    <div className='col-md-12 mt-3'>
                        <label htmlFor="users_firstname">Password Lama</label>
                    </div>

                    <div className='input-group mt-3'>
                        <input
                            type={inputPassword.type}
                            onChange={value => handleInput(value, 'password_lama')}
                            className='form-control'
                            placeholder='Password Lama'
                            style={{ borderRight: 'none' }}
                        />

                        <span
                            className='input-group-text'
                            style={{ backgroundColor: '#FFFFFF', cursor: 'pointer' }}
                            onClick={() => handleChangeEyeIcon(inputPassword.icon)}>
                            <i className={inputPassword.icon}></i>
                        </span>
                    </div>
                    {errors?.password_lama ? <p className='text-danger mt-1'>{errors?.password_lama}</p> : null}

                    <div className='col-md-12 mt-3'>
                        <label htmlFor="users_firstname">Password Baru</label>
                    </div>

                    <div className='input-group mt-3'>
                        <input
                            type={inputPassword.type}
                            onChange={value => handleInput(value, 'password_baru')}
                            className='form-control'
                            placeholder='Password'
                            style={{ borderRight: 'none' }}
                        />

                        <span
                            className='input-group-text'
                            style={{ backgroundColor: '#FFFFFF', cursor: 'pointer' }}
                            onClick={() => handleChangeEyeIcon(inputPassword.icon)}>
                            <i className={inputPassword.icon}></i>
                        </span>
                    </div>
                    {errors?.password_baru ? <p className='text-danger mt-1'>{errors?.password_baru}</p> : null}

                    <div className='col-md-12 mt-3'>
                        <label htmlFor="users_firstname">Konfirmasi Password Baru</label>
                    </div>

                    <div className='input-group mt-3'>
                        <input
                            type={inputPassword.type}
                            onChange={value => handleInput(value, 'konfirmasi_password')}
                            className='form-control'
                            placeholder='Konfirmasi Password Baru'
                            style={{ borderRight: 'none' }}
                        />

                        <span
                            className='input-group-text'
                            style={{ backgroundColor: '#FFFFFF', cursor: 'pointer' }}
                            onClick={() => handleChangeEyeIcon(inputPassword.icon)}>
                            <i className={inputPassword.icon}></i>
                        </span>
                    </div>
                    {errors?.konfirmasi_password ? <p className='text-danger mt-1'>{errors?.konfirmasi_password}</p> : null}

                </Modal.Body>

                <Modal.Footer>
                    <Button
                        onClick={handleClose}
                        className='btn btn-sm btn-secondary rounded-pill'>Batal</Button>
                    <Button
                        onClick={onSubmit}
                        className='btn btn-sm rounded-pill'
                        disabled={loading.updatePassword}>
                        {loading.updatePassword ? 'Loading...' : 'Simpan'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default FormPasswrod;